import OpenCommentPanel from 'actions/task/open_comment_panel';
import { SidePanelType } from 'models/side_panel';

export default class OpenOrRefreshCommentPanel {
  constructor(context) {
    this.context = context;
  }

  run({ itemId, location }) {
    const sidePanel = this.context.stores.sidePanel.get();
    const commentPanel = this.context.stores.commentPanel.get();
    this.context.analytics.track('Task Comment Panel Opened', {
      itemId,
      location,
    });

    const refreshOnly = sidePanel.isShowing(SidePanelType.TASK) && commentPanel.selectedItemId === itemId;
    this.context.executeAction(OpenCommentPanel, { itemId, refreshOnly });
  }
}
